import Transform from 'ember-data/transform';
import { decamelize, camelize } from '@ember/string';
import { flatTransformKeys, recursiveTransformKeys } from 'cio/utils/objects';

// Note: We do not track changes.
// ⚠️ Do not use this on anything with mixed camelCase and snake_case keys ⚠️
// - original -> {"my_var": "1", "myOtherVar": "2"}
// - deserialize -> {"myVar":"1", "myOtherVar":"2"}
// - serialize ->  {"my_var": "1", "my_other_var": "2"}

interface TransformOptions {
  recursive?: boolean;
  depthLevel?: number;
  schemaDefaults?: Record<string, () => unknown>;
}

const DEFAULT_OPTIONS = {
  recursive: true,
  depthLevel: Infinity,
};

function getTransformFunction(options?: TransformOptions) {
  let opts = { ...DEFAULT_OPTIONS, ...options };
  return opts.recursive ? recursiveTransformKeys : flatTransformKeys;
}

export default class CamelCaseTransform extends Transform {
  // "options" isn't typed very well under our current Ember Data types version,
  // need to use "any"
  deserialize(serialized: any, options?: any & TransformOptions) {
    let func = getTransformFunction(options);
    let deserialized = func(serialized, camelize, options?.depthLevel);

    if (options?.schemaDefaults != null) {
      Object.keys(options.schemaDefaults).forEach((key) => {
        if (deserialized[key] == null) {
          deserialized[key] = options.schemaDefaults[key]();
        }
      });
    }

    return deserialized;
  }

  // "options" isn't typed very well under our current Ember Data types version,
  // need to use "any"
  serialize(deserialized: any, options?: any) {
    let func = getTransformFunction(options);
    return func(deserialized, decamelize, options?.depthLevel);
  }
}

declare module 'ember-data/types/registries/transform' {
  export default interface TransformRegistry {
    'camel-case': Record<string, any> | null;
  }
}
